module.exports = __webpack_public_path__ + "static/media/808clear.ecec4976.mp3";